import { useEffect, useRef, useState } from 'react';

const usePlayerBottomHeight = () => {
  const bottomRef = useRef<HTMLDivElement | null>(null);
  const [bottomHeight, setBottomHeight] = useState<number>();

  useEffect(() => {
    if (!bottomRef.current || bottomHeight) return;

    setBottomHeight(bottomRef.current.offsetHeight);
  }, [bottomRef.current]);

  return [bottomHeight, bottomRef] as const;
};

export default usePlayerBottomHeight;
